define(function(require, exports) {
    'use strict';

    // @ngInject
    exports.lpFocus = function ($rootScope, $timeout) {
        return function(name) {
            $timeout(function() {
                $rootScope.$broadcast('lpFocusId', name);
            }, 100);
        };
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/components/focus/scripts/services.js
// module id = 54
// module chunks = 0